import { Directive, Input, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { RootMenuItem, IMenuItemAction } from 'src/models/Menu';
import { DeviceDetectorService, ScreenDimensions } from 'src/app/services/device-detector.service';
import { AsgardFeatureNames } from 'src/models/AsgardFeatures';
import { MenuService } from 'src/app/services/menu.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[asgMenuItemAdjuster]',
    standalone: true
})
export class MenuItemAdjusterDirective implements AfterViewInit, OnDestroy {

  @Input('asgMenuItemAdjuster') menuItem: RootMenuItem | null = null;
  private readonly subscriptions: Subscription = new Subscription();

  constructor(
    private el: ElementRef,
    private deviceDetectorService: DeviceDetectorService,
    private menuService: MenuService,
  ) { }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.deviceDetectorService.deviceScreenDimensions$.subscribe((e: ScreenDimensions) => {
        setTimeout(this.handleScreenResize.bind(this), 0, e); // fix for ASG-1955
        // this.handleScreenResize(e);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private handleScreenResize(dimensions: ScreenDimensions): void {
    if (this.menuItem && this.menuItem.style) {
      if (dimensions.width <= this.menuItem.style.width) {
        this.handleLessWidthMenuItemAction(this.menuItem.style.action, this.menuItem.feature);
      } else {
        this.handleDefaultItemAction(this.menuItem.style.action, this.menuItem.feature);
      }
    }
  }

  private handleDefaultItemAction(action: IMenuItemAction, feature: AsgardFeatureNames): void {
    switch (action) {
      case IMenuItemAction.hide:
        this.show();
        break;
      case IMenuItemAction.showinburger:
        this.menuService.removeItemFromBurger(feature);
        this.show();
        break;
      case IMenuItemAction.collapse:
        this.menuService.unCollapseFeatures();
        break;
      default: break;
    }
  }

  private handleLessWidthMenuItemAction(action: IMenuItemAction, feature: AsgardFeatureNames): void {
    switch (action) {
      case IMenuItemAction.hide:
        this.hide();
        break;
      case IMenuItemAction.showinburger:
        this.menuService.addMenuItemToBurger(feature);
        this.hide();
        break;
      case IMenuItemAction.collapse:
        this.menuService.collapseFeatures();
        break;
      default: break;
    }
  }


  private hide(): void {
    this.el.nativeElement.style.display = 'none';
  }

  private show(): void {
    this.el.nativeElement.style.display = 'block';
  }

}
